import script from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=1329a947&lang=scss"

const __exports__ = script;

export default __exports__